<button mat-icon-button matTooltip="{{ 'menu.notifications' | translate }}">
    <mat-icon [matBadge]="badge()" matBadgeColor="warn" aria-hidden="false"
        [class.ringing]="badge()">notifications</mat-icon>
</button>